import { createGraphqlAiDataPolicyService } from './graphql-service';
import type { AiDataPolicyService } from './types';

let activeService: AiDataPolicyService | null = null;

export function getAiDataPolicyService(): AiDataPolicyService {
  activeService ??= createGraphqlAiDataPolicyService();
  return activeService;
}

export function setAiDataPolicyService(service: AiDataPolicyService | null): void {
  activeService = service;
}
